import { DateTime } from 'luxon';

export const NO_DATE = 'no date';

const parse = (date?: string | null) => {
    if (!date) return null;
    const parsed = DateTime.fromISO(date);
    return parsed.isValid ? parsed : null;
};

export const formatSessionDate = (date?: string | null) =>
    parse(date)?.toLocaleString(DateTime.DATE_MED) ?? NO_DATE;

export const formatSessionDateLong = (date?: string | null) =>
    parse(date)?.toLocaleString(DateTime.DATE_HUGE) ?? NO_DATE;

/** Undated sessions sort first rather than poisoning the comparator with NaN. */
export const sessionSortValue = (date?: string | null) => parse(date)?.toMillis() ?? 0;
